import { atom } from "recoil";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

export const jobsAtom = atom<any>({
  key: RecoilKeys.Jobs,
  default: [],
});
